import React from "react";
import { ReactNode } from "react";
import AppFooter from "./AppFooter";
import { Container } from "@chakra-ui/react";
import AppHeader from "./AppHeader/AppHeader";
import { Alert, Box, Link } from "@chakra-ui/react";
import { messages } from "../messages";

interface IAppWrapper {
  children: ReactNode | ReactNode[];
}

const AppWrapper: React.FC<IAppWrapper> = ({ children }: IAppWrapper) => {
  const renderMessages = (): JSX.Element => {
    return (
      <>
        {messages.map((message, index) => {
          return (
            <Alert.Root
              key={index}
              status={message.status}
              mb={0}
              variant={message.variant}
              bg={message.bg}
              color={message.color}
            >
              <Alert.Indicator />
              <Alert.Content>
                <Alert.Description>
                  <Box>
                    {message.content}
                    {message.link && (
                      <>
                        <br />
                        {message.link.description}
                      </>
                    )}
                  </Box>{" "}
                  {message.link && (
                    <>
                      <Link
                        href={message.link.href}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ textDecoration: "underline" }}
                      >
                        {message.link.text}
                      </Link>
                      .
                    </>
                  )}
                </Alert.Description>
              </Alert.Content>
            </Alert.Root>
          );
        })}
      </>
    );
  };

  return (
    <Container px={0} maxWidth={"full"} minW={"full"}>
      <AppHeader />
      {renderMessages()}
      {children}
      <AppFooter />
    </Container>
  );
};

export default AppWrapper;
